import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e80b94ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline-item" }
const _hoisted_2 = { class: "timeline-content" }
const _hoisted_3 = { class: "timeline-eyebrow" }
const _hoisted_4 = { class: "timeline-title" }
const _hoisted_5 = { class: "timeline-dates" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "timeline-link" }, "Se turen →", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-dot" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: `/trips/${_ctx.trip.year}`,
      class: "timeline-card"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "timeline-image",
          style: _normalizeStyle(_ctx.image ? { backgroundImage: `url(${_ctx.image})` } : {})
        }, null, 4),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.trip.year), 1),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.trip.location), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.formatDateRange(_ctx.trip.startDate, _ctx.trip.endDate)), 1),
          _hoisted_6
        ])
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_7
  ]))
}